import { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value = [], onChange, multiple = true, label = "Zdjęcia" }) {
  const images = Array.isArray(value) ? value : value ? [value] : [];
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    setUploading(true);
    try {
      const paths = [];
      for (const file of Array.from(files)) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        paths.push(data.path);
      }
      const next = multiple ? [...images, ...paths] : paths.slice(0, 1);
      onChange(multiple ? next : next[0] || "");
      toast.success("Przesłano");
    } catch (e) {
      toast.error("Błąd przesyłania pliku");
    } finally {
      setUploading(false);
    }
  };

  const remove = (p) => {
    const next = images.filter((x) => x !== p);
    onChange(multiple ? next : "");
  };

  return (
    <div>
      <p className="mb-2 text-sm font-medium">{label}</p>
      <div className="flex flex-wrap gap-3">
        {images.map((p) => (
          <div key={p} className="relative h-20 w-20 overflow-hidden rounded-lg border border-border">
            <img src={fileUrl(p)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => remove(p)} className="absolute right-0.5 top-0.5 rounded-full bg-black/60 p-0.5 text-white" data-testid="upload-remove">
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        <Button type="button" variant="outline" onClick={() => inputRef.current?.click()} disabled={uploading} className="h-20 w-20 flex-col gap-1" data-testid="upload-trigger">
          {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
          <span className="text-[10px]">Dodaj</span>
        </Button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={(e) => e.target.files.length && handleFiles(e.target.files)} data-testid="upload-input" />
    </div>
  );
}
